import { CalendarSourceStatus } from '../../../data/entities/calendar-source';

export const getSourceStatusMessage = (sourceStatus?: CalendarSourceStatus) => {
	switch (sourceStatus) {
		case 'pending':
			return 'Searching for calendar.';
		case 'error':
			return 'No calendar found.';
		case 'success':
			return 'Calendar found.';
		default:
			return '';
	}
};
